import colors from "../../../constants/colors";

const styles = (theme) => {
  return {
    box2: {
      marginLeft: "10%",
      marginRight: "10%",
      marginTop: "5%",
      marginBottom: "5%",
    },
    box: {
      marginLeft: "5%",
      marginRight: "5%",
    },
    error: {
      color: colors.htmlRed,
      fontSize: "15px",
      "font-family": "Montserrat",
    },
    label: {
      "white-space": "nowrap",
      [theme.breakpoints.down("sm")]: {
        fontSize: 13,
      },
      [theme.breakpoints.up("sm")]: {
        fontSize: 15,
      },
    },
  };
};

export default styles;
